export const STATUS_INIT = 'INIT';
export const STATUS_LOADING = 'LOADING';
export const STATUS_SUCCESS = 'SUCCESS';
export const STATUS_IDLE = 'IDLE';
export const STATUS_ERROR = 'ERROR';
